import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "StairsDown.svg",
  "use": "StairsDown.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"StairsDown.svg\"><path d=\"M54,52H10a2,2,0,0,1-2-2V44a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V34a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V24a2,2,0,0,1,2-2h9a1,1,0,0,0,1-1V14a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2V50A2,2,0,0,1,54,52ZM14.79,24.0039h5.2322a1.9981,1.9981,0,1,1,0,3.9961h-10.02A2,2,0,0,1,8,26.002V16.0225a2.0019,2.0019,0,0,1,4.0037,0v5.141l8.6242-8.5774a1.9894,1.9894,0,1,1,2.8043,2.8225Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol